import { Component, OnInit, Input, Output } from 'angular-ts-decorators';

/**
 * Component of the coreModule, meant for the demo page in core.
 *
 * Please note that the close and dismiss bindings are from $uibModalInstance.
 *
 * # Example
 * <pre>
 *   <modal-component></modal-component>
 * </pre>
 */
@Component({
  selector: 'modalComponent',
  template: require('./modal-component.html').default,
})
export class ModalComponentComponent implements OnInit {
  @Input() private resolve: any;
  @Output() private close: any;
  @Output() private dismiss: any;

  public items: any;
  public selected: any;

  constructor() {
    'ngInject';
  }

  ngOnInit() {
    this.items = this.resolve.items;
    this.selected = {
      item: this.items[0],
    };
  }

  ok = () => {
    this.close({ $value: this.selected.item });
  };

  cancel = () => {
    this.dismiss({ $value: 'cancel' });
  };
}
